// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ResponseHandler$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/ResponseHandler.mjs";

function execute(json) {
  var token = JSON.parse(JSON.stringify(json));
  return token.response.fare_estimate_token;
}

var FareEstimateResultHashStateMapper = {
  execute: execute
};

var execute$1 = execute;

var FareEstimateResultHashApiConfig = {
  execute: execute$1
};

var partial_arg = ResponseHandler$Catalyst.ResponseConverter;

var FareEstimateResultHashApiResponseConverter = partial_arg(FareEstimateResultHashApiConfig, ResponseHandler$Catalyst.DefaultErrorConverter);

export {
  FareEstimateResultHashStateMapper ,
  FareEstimateResultHashApiConfig ,
  FareEstimateResultHashApiResponseConverter ,
}
/* FareEstimateResultHashApiResponseConverter Not a pure module */
